import firebase from 'firebase/app';
import { store } from "./store"


firebase.auth().onAuthStateChanged(function(user) {
    if (user) {
        console.log("User logged in")
        store.commit("user/USER_DETAILS", user);
        store.dispatch("user/teamMemberDetails", user.uid);
        
        // Update team member details with current auth info
        const userData = {
            id: user.uid,
            name: {
                first: user.displayName ? user.displayName.split(' ')[0] : '',
                last: user.displayName ? user.displayName.split(' ').slice(1).join(' ') : ''
            },
            emailAddress: user.email,
            profileImage: user.photoURL
        };
        store.dispatch("user/updateTeamMemberDetails", userData);

    } else {
        store.commit("user/LOGOUT")
    }
})